<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Moments:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'MomentsImageDesktop')"
            [blockData]="block.variables?.MomentsImageDesktop ?? ''"
            [placeholder]="imageDesktopPlaceholder"
            variable="MomentsImageDesktop"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'MomentsImageMobile')"
            [blockData]="block.variables?.MomentsImageMobile ?? ''"
            [placeholder]="imageMobilePlaceholder"
            variable="MomentsImageMobile"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'MomentsAlt')"
            [blockData]="block.variables?.MomentsAlt ?? ''"
            [placeholder]="altPlaceholder"
            variable="MomentsAlt"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'MomentsHref')"
            [blockData]="block.variables?.MomentsHref ?? ''"
            [placeholder]="hrefPlaceholder"
            variable="MomentsHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'MomentsHrefSegmentRegex')"
            [selectedSegment]="block.variables?.MomentsHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
      </div>
    </div>

    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row">
          <div
            *ngIf="block.variables?.MomentsImageDesktop"
            class="row col-12 d-flex justify-content-start mt-3"
          >
            <span>Image desktop</span>
            <a
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.MomentsHref))"
              target="_blank"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.MomentsImageDesktop)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.MomentsAlt)"
              />
            </a>
          </div>
          <div
            *ngIf="block.variables?.MomentsImageMobile"
            class="row col-12 d-flex justify-content-end mt-3"
          >
            <span>Image mobile</span>
            <a
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.MomentsHref))"
              target="_blank"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.MomentsImageMobile)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.MomentsAlt)"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
